import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import {
    TextField
} from 'mui-rff';
import { numberFormat, amountFormatInput, filterOut, filterWithOutFormatting, getVehicleNumberDisplayValuesDWeb } from "../../../utils/utils";
function useRunAfterUpdate() {
    const afterPaintRef = React.useRef(null);
    React.useLayoutEffect(() => {
        if (afterPaintRef.current) {
            afterPaintRef.current();
            afterPaintRef.current = null;
        }
    });
    const runAfterUpdate = fn => (afterPaintRef.current = fn);
    return runAfterUpdate;
}
const TextInputState = (props) => {
    const { onChange, fromVehicle } = props;
    const runAfterUpdate = useRunAfterUpdate();
    const onInputChange = (evt) => {
        const input = evt.target;
        const text = input.value;
        const cursor = input.selectionStart;
        const [newValue, newCursor] = filterWithOutFormatting(text, cursor);
        if (typeof window != 'undefined') {
            window.requestAnimationFrame(() => {
                input.selectionStart = newCursor
                input.selectionEnd = newCursor
            })
        }
        evt.target.value = newValue;
        if (typeof onChange === 'function') {
            onChange(evt);
        }
        /*runAfterUpdate(() => {
            input.selectionStart = newCursor;
            input.selectionEnd = newCursor;
        });*/
    }
    return <TextField {...props} onChange={onInputChange} />
};
export default TextInputState;